import { render, staticRenderFns } from "./EditProfileMenu.vue?vue&type=template&id=f15e3612&scoped=true"
import script from "./EditProfileMenu.vue?vue&type=script&lang=js"
export * from "./EditProfileMenu.vue?vue&type=script&lang=js"
import style0 from "./EditProfileMenu.vue?vue&type=style&index=0&id=f15e3612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15e3612",
  null
  
)

export default component.exports